import { Box, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import i18n from '../../../common/i18n';
import Reveal from '../commons/Reveal';
import SectionHeading from '../commons/SectionHeading';
import ProductCard from '../commons/ProductCard';
import { getHomeProducts } from '../commons/homeData';
import { homeColors, sectionContentSx, sectionPadding } from '../style/homeStyles';

const Productos = ({ isMobile }) => {
  const products = getHomeProducts();

  return (
    <Box
      component="section"
      sx={{
        backgroundColor: isMobile ? homeColors.bg : homeColors.white,
        padding: sectionPadding(isMobile),
        textAlign: 'left',
      }}
    >
      <Box sx={sectionContentSx}>
        <SectionHeading
          eyebrow={i18n.homeSolutionsEyebrow}
          title={i18n.homeSolutionsTitle}
          titleFontSize={isMobile ? 28 : 40}
        />

        {/* Mobile: una tarjeta debajo de la otra. Desktop: dos columnas. */}
        <Grid container spacing={isMobile ? 0 : 2}>
          {products.map((product, index) => (
            <Grid item xs={12} lg={6} key={product.id} sx={{ marginBottom: isMobile ? '14px' : 0 }}>
              <Reveal delay={index * 80} sx={{ height: '100%' }}>
                <ProductCard product={product} isMobile={isMobile} />
              </Reveal>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

Productos.propTypes = {
  isMobile: PropTypes.bool,
};

Productos.defaultProps = {
  isMobile: false,
};

export default Productos;
